// Bottom-right footer hint — keyboard tip + DevTools link.
// DevTools link is dev-only; production ships just the toggle hint.

import { ExternalLink } from 'lucide-react';
import { useT } from '../i18n/index.js';
import { appDom } from '../lib/appDom.js';

const DEVTOOLS_URL = 'http://localhost:3220';

export function FooterHint() {
  const t = useT();
  return (
    <footer
      data-testid="footer-hint"
      {...appDom({ id: 'footer-hint', type: 'Text', role: 'text', scope: 'footer' })}
      className="pointer-events-none fixed bottom-1.5 left-(--centre-inset) hidden items-center gap-1 font-mono text-[11px] text-muted-foreground lg:flex"
    >
      <kbd className="pointer-events-auto rounded border border-border/60 bg-muted/40 px-1.5 py-0.5 text-[10px] font-medium text-foreground">
        `
      </kbd>
      <span>{t('footer.togglesDebug')}</span>
      {import.meta.env.DEV && (
        <>
          <span className="px-1">·</span>
          <span>{t('footer.devtools')}</span>
          <a
            href={DEVTOOLS_URL}
            target="_blank"
            rel="noreferrer"
            className="pointer-events-auto inline-flex items-center gap-0.5 font-medium text-foreground/80 hover:text-foreground"
          >
            :3220
            <ExternalLink className="size-3" aria-hidden />
          </a>
        </>
      )}
    </footer>
  );
}
